import { render, staticRenderFns } from "./Exceptions.vue?vue&type=template&id=65f07d0b"
import script from "./Exceptions.vue?vue&type=script&lang=js"
export * from "./Exceptions.vue?vue&type=script&lang=js"
import style0 from "./Exceptions.vue?vue&type=style&index=0&id=65f07d0b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports